import React from 'react';
import accountCancelled from '@/images/subscription/account_cancelled.png';
import { useSelector } from 'react-redux';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import ModalComponent from '@/components/common-components/ModalComponent/ModalComponent';

import '@/components/common-components/ModalComponent/_accountCancelledModal.scss';

import { handleLogout } from '@/utils/global';
import { JIM_HUBSPOT_MEETING_LINK } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/hubspot.js';
import Gleap from 'gleap';

import LogoutIcon from '@/components/Icons/icons/LogoutIcon';
import RightArrow from '@/components/Icons/icons/RightArrow';

interface AccountCancelledModalProps {
  show: boolean;
}

const AccountCancelledModal: React.FC<AccountCancelledModalProps> = ({ show }) => {
  const { userDetails } = useSelector((state: any) => state.user);

  return (
    <>
      <ModalComponent
        show={show}
        onClose={() => {}}
        width={733}
        outsideClickClose={false}
        style={{ height: '430px' }}
        bodyStyle={{ padding: 0 }}>
        <button className="subscription-modal-logout-button" onClick={handleLogout} type="button">
          <LogoutIcon color="#FFFFFF" />
          Logout
        </button>
        <div className={`modal-main-content account-cancelled-modal`}>
          <div className="left-modal-div">
            <>
              <h2 className="account-cancelled-modal-description-heading">You Cancelled </h2>
              <h2 className="account-cancelled-modal-description-heading">Your Account</h2>
              <div className="account-cancelled-modal-description-subheading">
                Looks like you cancelled your account.{' '}
                {userDetails?.accountVersion === 'v2'
                  ? ' We’re sad to see you go, but we hope you come back soon.'
                  : ''}
              </div>

              <div className="account-cancelled-modal-description-subheading" style={{ marginTop: '5px' }}>
                {userDetails?.accountVersion === 'v2'
                  ? 'In case you want to resume using SARAL, please choose one of the options below:'
                  : 'A lot has changed with our product and pricing since, we’re excited to walk you through it!'}
              </div>
            </>
          </div>
          <div className="right-modal-div">
            <div className="image-container account-cancelled-modal-illustration-container">
              <img width="100%" src={accountCancelled} alt="" />
            </div>
          </div>
        </div>
        <div className="modal-footer-button-container small-button-container account-cancelled-buttons-container">
          <ButtonComponent
            variant="secondary"
            className="learn-more-button"
            onClick={() => {
              Gleap.setTicketAttribute(
                'Intent',
                'I cancelled my old account in the past but now want to re-activate. Can you suggest next steps?'
              );
            }}>
            Message Support
          </ButtonComponent>

          <ButtonComponent
            style={{ width: '100%' }}
            onClick={() => {
              window.open(JIM_HUBSPOT_MEETING_LINK, '_blank');
            }}>
            Talk to Sales <RightArrow width={24} height={18} color={'white'} />
          </ButtonComponent>
        </div>
      </ModalComponent>
    </>
  );
};

export default AccountCancelledModal;
